<picture class="image-container">
  <img class="image dish-image"
    [lazyLoad]="dishCode | dishImage: ImageTypeEnum.sitePreview :  ImageFileTypeEnum.webp : true"
    [defaultImage]="defaultImage"
    [errorImage]="errorImage">
</picture>
